import { useState } from "react";
import { apiCallV2 } from "../../../../utils/api";

import toast from "react-hot-toast";
import CustomButton from "../../../../common/CustomButton";
import CustomInput from "../../../../common/CustomInput";
import { validations } from "../../../../constants";


function EmailVerify({ setUserToken, setUserData, SlideTo, setEmailToParent, token }) {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState(0); // 0 dormant, 1 checking
    const [success, setSuccess] = useState(false); // 0 dormant, 1 checking

    let isValidEmail = validations.emailRegex.test(email);

    const CheckEmail = async () => {
        if (status == 0) {
            const toastId = toast.loading("Checking Email...");
            setStatus(1);
            setEmailToParent(email);
            const res = await apiCallV2("GET", "check-company-user-email", "", "", {
                email_address: email,
                token: token,
            });
            setStatus(0);

            if (res.status == 200) {
                if (res.data.data.userData.length) {
                    setSuccess(true);
                    setUserToken(res.data.data.access_token);
                    setUserData(res.data.data.userData[0]);
                    toast.success('Verified!', {
                        id: toastId,
                        duration: 1000
                    });
                    SlideTo(2);
                } else {
                    toast.error('Email not found.', {
                        id: toastId,
                    });
                }
            } else {
                toast.error('Failed to check email.', {
                    id: toastId,
                });
            }

        }
    }

    return (
        <>
            <div id="cuv-email-verify">
                <h4>Enter your email address to verify.</h4>
                <CustomInput
                    type="text"
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                    }}
                />

                <div>
                    {
                        !success
                            ? <CustomButton
                                disabled={!isValidEmail}
                                onClick={() => {
                                    // SlideTo(0);
                                    CheckEmail();
                                }}
                            >
                                Verify
                            </CustomButton>
                            : <CustomButton
                                disabled={!isValidEmail}
                                onClick={() => {
                                    SlideTo(2);
                                    // CheckEmail();
                                }}
                            >
                                Proceed
                            </CustomButton>
                    }

                </div>
            </div>
        </>
    );
}

export default EmailVerify;